import { render, staticRenderFns } from "./Therapy_Form.vue?vue&type=template&id=0c5b2ae8&"
import script from "./Therapy_Form.vue?vue&type=script&lang=js&"
export * from "./Therapy_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports